import PropTypes from 'prop-types'

import { classNames } from '../../helpers'

/**
 * Einheitlicher Karten-Header: Titel, optionale Beschreibung, optionale Actions.
 *
 * Die explizite `text-lg`-Klasse ist Absicht: `tailwind.config.js` setzt via
 * `addBase` ein blankes `h2` auf `text-xl`. Ohne die Klasse springt der Titel
 * von 18px auf 20px.
 */
const SectionHeading = ({ id, title, description, actions, className }) => (
  <div
    className={classNames(
      'pb-5',
      actions && 'sm:flex sm:items-center sm:justify-between sm:gap-4',
      className
    )}
  >
    <div>
      <h2 id={id} className='text-lg font-medium leading-6 text-gray-900'>
        {title}
      </h2>
      {description && (
        <p className='mt-1 max-w-2xl text-sm text-gray-500'>{description}</p>
      )}
    </div>
    {actions && <div className='mt-2 flex-shrink-0 sm:mt-0'>{actions}</div>}
  </div>
)

SectionHeading.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string
}

SectionHeading.defaultProps = {
  id: undefined,
  description: undefined,
  actions: undefined,
  className: undefined
}

export default SectionHeading
